import React from 'react';
import app from 'new-ui/app';
import { TAB_IDS, VERSIONS } from 'components/PageHeader/constants';
import { useProviderSpecificConfiguration } from 'modules/appConfiguration/useProviderSpecificConfiguration';
import './chatPage.css';
import { NewUserChat } from 'chat/NewUserChat/NewUserChat';
import { useSetHeaderSettings } from 'components/PageHeader/PageHeaderContext';
import { isNewlyDiagnosedUser } from 'modules/user/utils';
import { useOtherCancerRedirect } from 'utils/hooks/useOtherCancerRedirect';

const ChatPage = () => {
  useOtherCancerRedirect();
  const providerSpecificConfiguration = useProviderSpecificConfiguration();

  useSetHeaderSettings({
    version: VERSIONS.PATIENT_MAIN,
    isProfileButtonShown: false,
    tabIds: [
      TAB_IDS.FEED,
      TAB_IDS.TREATMENT_OPTIONS,
      TAB_IDS.SUPPORT_PROGRAMS,
      ...(providerSpecificConfiguration.symptomCareDisabled ? [] : [TAB_IDS.SYMPTOM_CARE]),
      ...(isNewlyDiagnosedUser(app?.user) ? [TAB_IDS.ARTICLES] : []),
      TAB_IDS.SPEAK_WITH_TINA,
    ],
  });

  return (
    <div className="full-screen-chat">
      <div className="full-screen-chat-width">
        <NewUserChat />
      </div>
    </div>
  );
};

export default ChatPage;
